/**
 * The nine Machanicdesk exports, as the slots they are dropped on.
 *
 * 🔑 The ORDER is the content. Each slot is numbered, and the batch uploads them in
 * this order, so the one thing that used to go wrong — a dependent file imported
 * before the one it needs — cannot happen by hand any more. Four of these attach to
 * something another file creates: lines need their invoice or quote, payments and
 * credit notes need their invoices, everything needs customers.
 *
 * 🔑 Jobs come AFTER the invoices now. A job's history entry takes its date from the
 * invoice and its work items from the invoice lines, so the invoices and their lines
 * have to be there before the job that carries them is read.
 *
 * Data, not JSX, so a slot can be added without editing the component that renders
 * them, and so the numbering, the labels and the detection all read from one list.
 */
export const SLOTS = [
    { kind: 'CUSTOMERS', label: 'Customers', hint: 'First. Everything attaches to these.' },
    { kind: 'CUSTOMER_CONTACTS', label: 'Customer Contacts', hint: 'Who to ring at a business.' },
    { kind: 'INVOICES', label: 'Invoices Summary', hint: 'The invoices, and their totals.' },
    { kind: 'INVOICE_ITEMS', label: 'Invoice Items', hint: 'Priced lines. Needs the summary.' },
    {
        kind: 'JOBS', label: 'Jobs',
        hint: 'Becomes service history, with the invoice lines as its work items.',
    },
    { kind: 'QUOTES', label: 'Quotes', hint: 'Quotes given. No jobs created.' },
    { kind: 'QUOTE_ITEMS', label: 'Quote Items', hint: 'Priced lines. Needs Quotes.' },
    { kind: 'INVOICE_PAYMENTS', label: 'Invoice Payment', hint: 'Folds into what was paid.' },
    { kind: 'CREDIT_NOTES', label: 'Credit Notes', hint: 'Refunds, as negative invoices.' },
];

/** The slot for an export kind, or undefined for one this product does not read. */
export function slotFor(kind) {
    return SLOTS.find((s) => s.kind === kind);
}

/** The 1-based number printed on the slot — what a person is told to look for. */
export function slotNumber(kind) {
    const index = SLOTS.findIndex((s) => s.kind === kind);
    return index === -1 ? null : index + 1;
}
